import axios from 'axios';

export const videoPackages = [
  '6ff8d6a7-4867-419f-9d29-e1121efed45c',
  '13baab32-8d8e-4022-8608-d21ffe868a67',
  '9d09320f-1013-4306-813c-14fbe65833fe',
  '17f1b420-2793-467c-905c-e17f47d7d8dd'
]

export const audioPackages = [
  '9d09320f-1013-4306-813c-14fbe65833fe',
  '17f1b420-2793-467c-905c-e17f47d7d8dd'
]

export const liveVideoKSession = '0_20enyw7j';
export const liveAudioKSession = '0_m8j3u06y';

class StreamAMG {

  constructor(data, language) {

    this.config = {
      apiUrl: `${process.env.GATSBY_STREAMAMG_URL}/api/v1`,
      apiLanguage: typeof data === 'string' && language ? language : typeof data === 'object' ? data.language : 'en',
      sessionDataName: "StreamPaymentSessionData",
      packagesName: "StreamPaymentPackages",
      loginCallbackName: "StreamPaymentLoginCallback",
      jwtToken: typeof data === 'object' ? data.jwtToken : '',
      jwtLogin: typeof data === 'object' && data.jwtToken ? true : false,
    }

    const loginCallback = this.#getCachedData(this.config.loginCallbackName);
    if (loginCallback) {
      localStorage.removeItem(this.config.loginCallbackName);
      const sessionData = this.#getCachedData(this.config.sessionDataName);
      loginCallback(sessionData);
    }
    // this.registerRedirectCleans();
  }

  getSubscriptionPackageList = (options, callback) => {
    const _this = this;
    const packages = this.#getCachedData(this.config.packagesName);
    if (packages) {
      this.#doCallback(callback, packages);
      return
    }

    axios({
      method: 'get',
      url: this.#prepAjaxUrl(`${this.config.apiUrl}/package/`),
      params: options,
    }).then((res) => {
      _this.#doCallback(callback, res.data)
    }).catch((err) => {
      console.log('getSubscriptionPackageList Error', err);
    })
  };

  getSessionState = (options, callback) => {
    const _this = this;

    console.log("getSessionState called");

    // eslint-disable-next-line no-undef
    if (typeof streamLocalSessionDataInUse !== 'undefined' && streamLocalSessionDataInUse === true) {
      console.log("Returning streamLocalSessionData");
      // eslint-disable-next-line no-undef
      this.#doCallback(callback, streamLocalSessionData);
      return;
    }

    var sessionData = this.#getCachedData(this.config.sessionDataName);
    var sessionDataValid = false;

    if (sessionData && sessionData.CurrentCustomerSession) {
      sessionDataValid = true;
      var cacheLastUpdatedAt = new Date(sessionData.UpdatedAt);
      var cacheMaxLastUpdatedAt = new Date();
      cacheMaxLastUpdatedAt.setMinutes(cacheMaxLastUpdatedAt.getMinutes() - 5);

      // if the cache hasnt expired
      if (cacheLastUpdatedAt < cacheMaxLastUpdatedAt) {
        console.log("Cached session state has expired");
        sessionDataValid = false;
      }

      // if we are using jwt we should check the session key
      if(this.config.jwtLogin) {
        if (!sessionData.JwtTokenCacheKey) {
          console.log("Cached session does not have a JwtTokenCacheKey");
          sessionDataValid = false;
        }
        if (sessionData.JwtTokenCacheKey != this.config.jwtToken) {
          console.log("Cached session JwtTokenCacheKey does not match initlaized cache key");
          sessionDataValid = false;
        }
      }
    }

    if (sessionDataValid) {
      console.log("Using cached value");
      this.#doCallback(callback, sessionData);
      return
    }

    axios({
      method: 'get',
      url: this.#prepAjaxUrl(`${this.config.apiUrl}/session/prescence/`),
      params: options,
    }).then((res) => {
      _this.#sessionUpdateReceived(res.data, true);
      _this.#doCallback(callback, res.data)
    }).catch((err) => {
      console.log('getSessionState Error', err);
    })
  };

  doLogin = (options, callback) => {
    const _this = this;
    if (this.config.jwtLogin) {
      console.log("doLogin is not supported for JWT authentication");
      return
    }

    axios({
      method: 'get',
      url: this.#prepAjaxUrl(`${this.config.apiUrl}/session/start/`),
      params: options,
    }).then((res) => {
      const data = res.data;
      if (Object.keys(data.ModelErrors).length === 0 && data.PageUrl === null) {
        _this.#sessionUpdateReceived(data, true);
        localStorage.setItem(_this.config.loginCallbackName, callback);

        const search = window.location.search ? window.location.search + "&callbackurl=" + encodeURIComponent(window.location.href) : "?callbackurl=" + encodeURIComponent(window.location.href);
        const completePath = _this.config.apiUrl + "/session/setcookie/" + data.AuthenticationToken + search;

        console.log('Commplete path:' + completePath);

        window.location.href = completePath;
        return
      }

      _this.#doCallback(callback, res.data)
    }).catch((err) => {
      console.log('doLogin Error', err);
    })
  };

  doLoginPost = (options, callback) => {
    if (this.config.jwtLogin) {
      console.log("doLogin is not supported for JWT authentication");
      return;
    }

    const _this = this;

    const deserialize = (serializedString) => {
      serializedString = serializedString.replace(/\+/g, '%20');
      var formFieldArray = serializedString.split("&");

      return formFieldArray.reduce((x, obj) => {
        const nameValue = x.split("=");
        const name = decodeURIComponent(nameValue[0]);
        const value = decodeURIComponent(nameValue[1]);
        obj[name] = value
        return obj
      }, {})
    }

    const postData = deserialize(options);

    axios({
      method: 'post',
      url: this.#prepAjaxUrl(`${this.config.apiUrl}/session/start/`),
      data: JSON.stringify(postData),
    }).then((res) => {
      const data = res.data
      if (Object.keys(data.ModelErrors).length === 0) {
        _this.#sessionUpdateReceived(data, true);
        localStorage.setItem(_this.loginCallbackName, callback);

        const search = window.location.search ? window.location.search + "&callbackurl=" + window.location.href : "?callbackurl=" + window.location.href;
        window.location.href = _this.config.apiUrl + "/session/setcookie/" + data.AuthenticationToken + search;
        return;
      }
      _this.doCallback(callback, res.data)
    }).catch((err) => {
      console.log('doLoginPost Error', err);
    })
  };

  doLogout = (options, callback) => {
    const _this = this;
    axios({
      method: 'get',
      url: this.#prepAjaxUrl(`${this.config.apiUrl}/session/terminate/`),
      params: options,
    }).then((res) => {
      _this.cleanStatus()
      _this.doCallback(callback, res.data)
    }).catch((err) => {
      console.log('doLogout Error', err);
    })
  };

  getKSession = (options, callback) => {
    const _this = this;

    axios({
      method: 'get',
      url: this.#prepAjaxUrl(`${this.config.apiUrl}/session/ksession/`),
      params: options,
    }).then((res) => {
      const data = res.data
      if (data != null && data.ErrorMessage != null) {
          console.log(data.ErrorMessage);
      }
      _this.#doCallback(callback, data);
    }).catch((err) => {
      console.log('getKSession Error', err);
    })
  };

  isEmailAddressValid = (options, callback) => {
    const _this = this;

    axios({
      method: 'post',
      url: `${this.config.apiUrl}/user/isvalidemail/?lang=${this.config.apiLanguage}`,
      data: JSON.stringify(options),
    }).then((res) => {
      _this.#doCallback(callback, res.data);
    }).catch((err) => {
      console.log('isEmailAddressValid Error', err);
    })
  };

  isEmailAddressRegistered = (options, callback) => {
    if (this.config.jwtLogin) {
      console.log("isEmailAddressRegistered is not supported for JWT authentication");
      return;
    }

    const _this = this;

    axios({
      method: 'post',
      url: `${this.config.apiUrl}/user/isregisteredemail/?lang=${this.config.apiLanguage}`,
      data: JSON.stringify(options),
    }).then((res) => {
      _this.#doCallback(callback, res.data);
    }).catch((err) => {
      console.log('isEmailAddressRegistered Error', err);
    })
  };

  isVoucherCodeValid = (options, callback) => {
    const _this = this;

    axios({
      method: 'get',
      url: `${this.config.apiUrl}/offervoucher/getstatusbycode/?lang=${this.config.apiLanguage}`,
      params: options,
    }).then((res) => {
      _this.#doCallback(callback, res.data);
    }).catch((err) => {
      console.log('isVoucherCodeValid Error', err);
    })
  };

  doContactSubmission = (options, callback) => {
    const _this = this;

    axios({
      method: 'post',
      url: `${this.config.apiUrl}/contact`,
      data: JSON.stringify(options),
    }).then((res) => {
      _this.#doCallback(callback, res.data);
    }).catch((err) => {
      console.log('doContactSubmission', err);
    })
  };

  //*** Private functions ***//

  #doCallback = (fn, data) => {
    if (typeof fn === "function") {
      fn(data);
      return;
    }
    console.log("stream-payments - callback fn not set!");
  };

  #getCachedData = (id) => {
    const data = localStorage.getItem(id);
    if (!data) {
      return;
    }

    if (data.indexOf("function") === 0) {
      // var fn = () => {}
      eval(data.replace("function", "fn = function"));
      // eslint-disable-next-line no-undef
      return fn;
    }

    return JSON.parse(data);
  };

  #sessionUpdateReceived = (data, store) => {
    if (store) {
      data.UpdatedAt = new Date();

      if (this.config.jwtLogin) {
        data.JwtTokenCacheKey = this.config.jwtToken;
      }

      localStorage.setItem(this.config.sessionDataName, JSON.stringify(data));
    }
  };

  #cleanStatus = () => {
    localStorage.removeItem(this.config.sessionDataName);
  };

  #registerRedirectCleans = () => {
      // $("a").click(function () {
      //     var url = $(this).attr("href");

      //     if (url && url.indexOf("https://fgr-payments-staging.streamamg.com/") !== -1) {
      //         cleanStatus();
      //     }
      // });
  };

  #prepAjaxUrl = (url) => {
    const language = `?lang=${this.config.apiLanguage}`
    const jwtLogin = this.config.jwtLogin ? `&apijwttoken=${this.config.jwtToken}` : ''
    return `${url}${language}${jwtLogin}`
  }
}

export default StreamAMG;
